<script>
    export let issues = []
</script>
{#if issues.length > 0}
    <div class="ui error message">
        <!-- <i class="close icon"></i> -->
        <div class="header">
            <slot></slot>
        </div>
        <ul class="list">
            {#each issues as iss}
                <li>{iss.description}</li>
            {/each}
        </ul>
    </div>            
{/if}
